// ResetPasswordSuccessPage.tsx
import { Button } from '@mui/material';
import { styled } from '@mui/system';

export const ActionButton = styled(Button)`
  max-width: 240px;
  width: 100%;
  height: 56px;
`;
